import useCategories from './useCategories';

export default useCategories;
